import { Component } from '@theme/component';

class FamilySelector extends Component {
  requiredRefs = ['backdrop', 'drawer', 'closeBtn'];

  #isOpen = false;
  #savedScrollY = 0;
  #keyHandler = null;
  #previousActiveEl = null;

  connectedCallback() {
    super.connectedCallback();
    const { backdrop, drawer, closeBtn } = this.refs;
    document.body.append(backdrop, drawer);
    backdrop.addEventListener('click', () => this.closeDrawer());
    closeBtn.addEventListener('click', () => this.closeDrawer());
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.#keyHandler) {
      document.removeEventListener('keydown', this.#keyHandler);
      this.#keyHandler = null;
    }
    this.#isOpen = false;
    document.body.style.overflow = '';
  }

  openDrawer() {
    if (this.#isOpen) return;
    const { drawer, backdrop } = this.refs;
    this.#isOpen = true;
    this.#savedScrollY = window.scrollY;
    this.#previousActiveEl = document.activeElement;
    drawer.hidden = false;
    backdrop.hidden = false;
    document.body.style.overflow = 'hidden';

    this.#keyHandler = (event) => {
      if (event.key === 'Escape') this.closeDrawer();
    };
    document.addEventListener('keydown', this.#keyHandler);

    requestAnimationFrame(() => {
      drawer.classList.add('family-selector__drawer--open');
      backdrop.classList.add('family-selector__backdrop--visible');
    });

    const firstFocusable = drawer.querySelector('button, a[href]');
    if (firstFocusable instanceof HTMLElement) firstFocusable.focus();
  }

  closeDrawer() {
    if (!this.#isOpen) return;
    const { drawer, backdrop } = this.refs;
    this.#isOpen = false;
    drawer.classList.remove('family-selector__drawer--open');
    backdrop.classList.remove('family-selector__backdrop--visible');

    if (this.#keyHandler) {
      document.removeEventListener('keydown', this.#keyHandler);
      this.#keyHandler = null;
    }

    const previousEl = this.#previousActiveEl;
    this.#previousActiveEl = null;

    const onEnd = () => {
      drawer.removeEventListener('transitionend', onEnd);
      drawer.hidden = true;
      backdrop.hidden = true;
      document.body.style.overflow = '';
      window.scrollTo(0, this.#savedScrollY);
      if (previousEl instanceof HTMLElement && document.contains(previousEl)) {
        previousEl.focus();
      }
    };

    drawer.addEventListener('transitionend', onEnd, { once: true });
    setTimeout(onEnd, 300);
  }
}

customElements.define('custom-family-selector', FamilySelector);
